import $ from 'jquery';

function toParamString(obj) {
  return Object.keys(obj).filter((key) => obj[key] !== '')
    .map((key) => `${key}=${obj[key]}`)
    .join('&')
}

function makeRequeryUrl(docid, utf8Query, currParamString) {
  const blacklist = ['m', 'q'];

  const params = currParamString
    .slice(1)
    .split('&')
    .map((keyValue) => {
      const [key, val] = keyValue.split('=');
      return {key: decodeURIComponent(key), val: decodeURIComponent(val)};
    })
    .filter((param) => !blacklist.includes(param.key))
    .filter((param) => typeof param.val === 'string')
    .filter((param) => param.val.length > 0)
    .map((param) => ({[encodeURIComponent(param.key)]: encodeURIComponent(param.val)}))
    .reduce((acc, curr) => $.extend({}, acc, curr), {});

  const extendedParams = $.extend({}, params, {
    w: 'img',
    DA: 'IIM',
    q: utf8Query,
    docid
  });

  return `?${toParamString(extendedParams)}`;
}

export default makeRequeryUrl;



/** WEBPACK FOOTER **
 ** ./src/IIM/core/utils/makeRequeryUrl.js
 **/